import { Capacitor } from "@capacitor/core"
import { Dialog } from "@capacitor/dialog"
import { LiveUpdate } from "@capawesome/capacitor-live-update"
import posthog from "posthog-js"
import * as m from "@/paraglide/messages"

export function initLiveUpdate() {
	if (!Capacitor.isNativePlatform()) return
	if (!Capacitor.isPluginAvailable("LiveUpdate")) return

	LiveUpdate.ready()
		.then((result) => {
			if (!result.rollback) return
			// A slow default bundle that misses readyTimeout also reports a
			// rollback, but there is no bundle to go back from.
			if (result.previousBundleId === null) return
			// app_version on this event already belongs to the restored bundle.
			posthog.capture("ota_rollback", {
				previous_bundle_id: result.previousBundleId,
				current_bundle_id: result.currentBundleId,
			})
		})
		.catch((e) => {
			posthog.captureException(e, { scope: "liveUpdate.ready" })
		})

	LiveUpdate.addListener("nextBundleSet", async (event) => {
		if (!event.bundleId) return
		try {
			const { value } = await Dialog.confirm({
				title: m.otaUpdateTitle(),
				message: m.otaUpdateMessage(),
				okButtonTitle: m.otaUpdateBtnInstall(),
				cancelButtonTitle: m.otaUpdateBtnLater(),
			})
			if (value) await LiveUpdate.reload()
		} catch (e) {
			posthog.captureException(e, { scope: "liveUpdate.nextBundleSet" })
		}
	})
}
